import axios from 'axios'

class StatsService {

    async widgetViewed({widgetId}) {
        const data = {
            event: {
                type: 'page_view',
                widgetId: parseInt(widgetId)
            }
        }

        return await axios.post(process.env.VUE_APP_GUESTFLIP_API_BASE_URL + '/widget/event', data)
    }

    async widgetVisited({widgetId}) {
        const data = {
            event: {
                type: 'page_visit',
                widgetId: parseInt(widgetId)
            }
        }

        return await axios.post(process.env.VUE_APP_GUESTFLIP_API_BASE_URL + '/widget/event', data)
    }

    async postClicked({widgetId, postId}) {
        const data = {
            event: {
                type: 'post_click',
                widgetId: parseInt(widgetId),
                postId: parseInt(postId)
            }
        }

        return await axios.post(process.env.VUE_APP_GUESTFLIP_API_BASE_URL + '/widget/event', data)
    }

    async actionPerformed({widgetId, postId}) {
        const data = {
            event: {
                type: 'action_performed',
                widgetId: parseInt(widgetId),
                postId: parseInt(postId)
            }
        }

        return await axios.post(process.env.VUE_APP_GUESTFLIP_API_BASE_URL + '/widget/event', data)
    }
}

export default new StatsService()